
    import Vue from 'vue';
    import {mapMutations, mapState} from 'vuex';
    import {mask} from 'vue-the-mask';
    import { CalendarIcon } from 'vue-feather-icons';
    // Store
    import UnitPlan from "@/store/units/UnitPlan";
    import _ from 'lodash';

    function requestDefaultValues() {
        return {
            school_id: null,
            planType: 1,
            classDays: [],
            name: null,
            name2: '',
            hours: '00',
            subject: null,
            schoolLevel: null,
            course: null,
            courseName: '',
            year: new Date().getFullYear(),
            startDate: '',
            endDate: '',
            oas: [],
            roma: false,
            copyFromCourse: false,
            selectedYearToCopy: 0,
            selectedCourseToCopy: 0,
            copyOAs:true,
            copyCoverage:true,
            copyActivities:true,
            pie: false,
            mapped: {},
            prioridad: 'Sin Priorización',
        };
    }

    // @ts-ignore
    export default Vue.extend({
        name: 'RomaUnitModalForm',
        props: {
            modalTittle: {
                type: String,
                required: true,
            },
            modalAction:{
                type: String,
                required: true,
                default:'Add',
            },
            value: Boolean,
            unit: Object,
            school: {
                type: Object,
                required: true,
            },
            maxWidth: {
                type: String,
                default: '1100',
            },
            overlayOpacity: {
                type: String,
                default: '0.8',
            },
            persistent: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                request: requestDefaultValues(),
                valid: false,
                loading: false,
                showing: this.value,
                startDateMenu: false,
                endDateMenu: false,
                educationsList: [],
                categoriesList: [],
                sectionsList: [],
                oas: [],
            };
        },

        updated(){
            if(this.modalAction==='Duplicate'){
                this.request.copyFromCourse = true;
                this.request.selectedYearToCopy = this.unit.year;
            }
        },

        computed: {
            getSectionsByEducationsLevel() {
                return this.sectionsList.filter((section: any) => this.request && this.request.schoolLevel && section.categoria.id === this.request.schoolLevel.id);
            },
            getSubjectsBySection(){
                return this.request.course? this.request.course.subjects : [];
            },
            filteredYearsToCopy() {
                if (!this.request.subject || this.request.subject.id <= 0
                    || !this.request.schoolLevel || this.request.schoolLevel.id <= 0
                    || !this.request.name || this.request.name.id <= 0
                    || !this.request.course || this.request.course.idSeccion <= 0) {
                    this.request.selectedYearToCopy = null;

                    return [];
                }

                const arr: any[] = this.roma.cursosParaCopiar.filter((course: any) => course.asignatura_id === this.request.subject.id
                    && course.categoria_id === this.request.schoolLevel.id && course.unidad_id === this.request.name.id
                    && (course.id !== this.request.course.idSeccion || ((this.user.roles.includes('Coordinador PIE') && !this.user.roles.includes('Profesor'))
                        || this.request.pie)));

                if (arr.length <= 0){
                     this.request.selectedYearToCopy = null;
                     return [];
                }

                const yearsSet = new Set<Number>();

                arr.filter((course:any) => course.periodYear)
                .forEach((course:any) => yearsSet.add(course.periodYear));

                const years:Number[] = Array.from(yearsSet);
                years.sort();
                return years;
            },

            filteredCoursesToCopy() {
                if (!this.request.subject || this.request.subject.id <= 0
                    || !this.request.schoolLevel || this.request.schoolLevel.id <= 0
                    || !this.request.name || this.request.name.id <= 0
                    || !this.request.course || this.request.course.idSeccion <= 0) {
                    this.request.selectedCourseToCopy = null;

                    return [];
                }

                const arr: any[] = this.roma.cursosParaCopiar.filter((course: any) => course.asignatura_id === this.request.subject.id
                    && course.categoria_id === this.request.schoolLevel.id && course.unidad_id === this.request.name.id

                    && (!this.request.selectedYearToCopy ||
                        (course.periodYear && course.periodYear === this.request.selectedYearToCopy ))

                    && (course.id !== this.request.course.idSeccion ||
                        ((this.user.roles.includes('Coordinador PIE') && !this.user.roles.includes('Profesor')) ||
                            this.request.pie)));

                if (arr.length <= 0){
                    this.request.selectedCourseToCopy = null;
                }

                return arr;
            },
            filteredCoursesDestination(){
                if(!this.request.schoolLevel || this.modalAction!=='Duplicate' ){
                    return [];
                }

                let courses:any[] = [];

                /*if(this.request.course && this.request.schoolLevel.cursos &&
                    parseInt(this.request.selectedYearToCopy) ===
                    parseInt(this.getSelectedSchoolYear()? this.getSelectedSchoolYear() : this.request.year)){
                    courses = this.request.schoolLevel.cursos.filter((course:any) => course.id!== this.request.course.id);
                }else{*/
                courses = this.sectionsList.filter((section:any) => {
                    return section.categoria.id === this.request.schoolLevel.id
                });

                courses = courses.filter((section: any) => {
                    return section.subjects.some((subject: any) => subject.id === this.request.subject.id);
                });

                //}

/*
                const coursesToRemove:any[] = this.roma.cursosParaCopiar.filter((course: any) =>
                    course.asignatura_id === this.request.subject.id
                    && course.categoria_id === this.request.schoolLevel.id
                    && course.unidad_id === this.request.name.id
                    && parseInt(course.periodYear) === parseInt(this.getSelectedSchoolYear()? this.getSelectedSchoolYear() : this.request.year));

                if(coursesToRemove){
                    return courses.filter((course:any) =>
                        !coursesToRemove.find((toRemove:any) => course.id === toRemove.id));
                }
*/

                return courses;

            },
            units () {
                return UnitPlan.all();
            },
            unitNames () {
                let unitNames = [];

                for (let n = 1; n <= 7; n++) {
                    unitNames.push('Unidad ' + n)
                }

                return unitNames;
            },
            ...mapState([
                'roma',
                'user'
            ]),
        },
        methods: {
            ...mapMutations(['appLoading']),
            allowDate: (date: string): boolean => {
                const arg: string[] = date.split('-');
                const dateParsed: Date = new Date(Number.parseInt(arg[0]), Number.parseInt(arg[1]) - 1, Number.parseInt(arg[2]));
                return dateParsed.getDay() !== 6 && dateParsed.getDay() !== 0;
            },
            showCourseToCopy() {
                this.$refs.createUnitForm.validate();
            },
            getSelectedSchoolYear(){
                return JSON.parse(localStorage.getItem('roma')) && JSON.parse(localStorage.getItem('roma')).organizer &&
                    JSON.parse(localStorage.getItem('roma')).organizer.selectedSchool ?
                    JSON.parse(localStorage.getItem('roma')).organizer.selectedSchool.yearSelected : null;
            },
            show(show: boolean, getUnitPlans?: boolean) {
                this.$emit('input', show);
                if (getUnitPlans) this.$emit('getunitplans');
                if (!this.unit || this.unit.id <= 0) this.request = requestDefaultValues();
            },

            async setUnit() {
                this.loading = true;
                this.appLoading();
                this.request.school_id = this.school.id;

                // Implementación con el end point

                // mapeo con backend
                if (this.request.id > 0) {
                    this.request.mapped.id = this.request.id;
                    delete this.request.oas;

                }

                this.request.mapped.idUnidad = this.request.name ? this.request.name.id : null;
                this.request.mapped.nombre = this.request.name2;
                this.request.mapped.fechaInicio = this.request.startDate;
                this.request.mapped.fechaFin = this.request.endDate;
                this.request.mapped.horas = this.request.hours;
                this.request.mapped.idAsignatura = this.request.subject.id;
                this.request.mapped.idCategoria = this.request.course.categoria.id;

                if (this.request.course && this.request.course.idSeccion > 0){
                    this.request.mapped.idSeccion = this.request.course.idSeccion;
                }

                this.request.mapped.getPlanByRoma = true;
                
                this.request.mapped.idSeccionToCopyFromCurso =
                (this.modalAction!=='Duplicate' && (this.user.institution.type.implementador || this.request.mapped.getPlanByRoma || this.request.id)) ? 0 :
                    ((this.request.selectedCourseToCopy > 0) ? this.request.selectedCourseToCopy : 0);

                if(this.request.mapped.idSeccionToCopyFromCurso != 0){
                    const seccionOrigen = this.sectionsList.find((seccion: any) => {
                        return seccion.idSeccion == this.request.mapped.idSeccionToCopyFromCurso
                    });

                    const year = this.getSelectedSchoolYear()? this.getSelectedSchoolYear() : this.request.year;
                    const response = await this.$store.dispatch('getSectionWithSubjects', year);
                    
                    
                    const seccionActual = response.data.content.secciones.find((seccion: any) => {
                        return seccion.categoria.id ==  seccionOrigen.categoria.id && seccion.nombre == seccionOrigen.nombre
                    });

                    if(seccionActual){
                        this.request.mapped.idSeccion = seccionActual.idSeccion;
                    }
                }


                if(this.unit && this.unit.id){
                    this.request.mapped.idToCopyFromCurso = this.unit.id;
                }
                this.request.mapped.pie = (this.user.roles.includes('Coordinador PIE') && !this.user.roles.includes('Profesor')) || this.request.pie;
                this.request.mapped.priority = this.request.prioridad;

                this.request.mapped.selectedYearToCopy = (this.user.institution.type.implementador || this.request.mapped.getPlanByRoma || this.request.id) ? 0 : ((this.request.selectedYearToCopy > 0) ? this.request.selectedYearToCopy : 0);
                this.request.mapped.copyOAs = this.request.mapped.pie || this.request.copyOAs;
                this.request.mapped.copyCoverage = this.request.mapped.pie || this.request.copyCoverage;
                this.request.mapped.copyActivities = this.request.mapped.pie || this.request.copyActivities;
                this.request.mapped.action = this.modalAction;
                this.request.mapped.diasDeClase = this.request.classDays;
                this.request.mapped.tipoPlanUnidad = this.request.planType;
                let msj = {
                    show: true,
                    text: '',
                    color: 'success',
                };
               
                const response = await this.$store.dispatch('createUnitPlan', this.request.mapped);
                this.$store.state.unitList.paginator.filter.level = this.request.schoolLevel.id;
                this.$store.state.unitList.paginator.filter.course = this.request.course.idSeccion;
                this.$store.state.unitList.paginator.filter.subject = this.request.subject.id;
                this.appLoading(false);
                if (response.data && response.data.status && response.data.status.code === 1) {
                    msj.text = 'Se ha guardado el plan unidad'
                    await this.$store.dispatch('roma', {});
                    this.$store.state.unitList.paginator.filter.plan = response.data.content.idPlanAnual;
                    this.show(false, true);
                } else if (response.data && response.data.status && response.data.status.code === 3) {
                    msj.text = response.data.content.message;
                    msj.color = 'red';

                } else {
                    msj.show = false;

                }
                
                this.$store.state.snackbar = msj;
                this.loading = false;
            },
            async getSections(){
                this.appLoading();
                const year = this.unit && this.unit.year? this.unit.year: this.getSelectedSchoolYear()? this.getSelectedSchoolYear() : this.request.year;
                //const year = this.getSelectedSchoolYear()? this.getSelectedSchoolYear() : this.request.year;
                const response = await this.$store.dispatch('getSectionWithSubjects', year);

                let secciones = _.orderBy(response.data.content.secciones, ['categoria.orden']);
                secciones = secciones.map((seccion: any) => {
                    seccion.abreviatura = seccion.abreviatura.replace(/-/g, ' ');
                    return seccion;
                });

                let educationsList = secciones.map((seccion: any) => {
                    return seccion.categoria.educacion;
                });

                let categoriesList = secciones.map((seccion: any) => {
                    return seccion.categoria;
                });

                educationsList = _.uniqBy(educationsList, 'id');
                categoriesList = _.uniqBy(categoriesList, 'id');

                educationsList = educationsList.map((education: any) => {
                    education.categorias = categoriesList.filter((category: any) => category.educacion.id === education.id);
                    return education;
                });

                categoriesList = [];

                educationsList.forEach((education: any) => {
                    categoriesList.push({
                        header: education.nombre,
                    });

                    education.categorias.forEach((category: any) => {
                        categoriesList.push(category);
                    });
                });

                this.educationsList = educationsList;
                this.categoriesList = categoriesList;
                this.sectionsList = secciones;

                if(this.unit && this.unit.id){
                    const category = this.sectionsList.find((section: any) => section.categoria.id === this.unit.id_nivel).categoria;
                    this.request.schoolLevel = category;
                    
                    await this.$nextTick();
                    let seccion = this.sectionsList.find((section: any) => {
                        return section.idSeccion == this.unit.id_seccion
                    });

                    //Esta sección del código es para hacer retrocompatible con una lógica que se usaba mucho tiempo antes de corregir el mapeo al duplicar planes 
                    if(!seccion){
                        let yearToLook = (+year) - 1;
                        const response = await this.$store.dispatch('getSectionWithSubjects', yearToLook);
                        seccion = response.data.content.secciones.find((section: any) => {
                            return section.idSeccion == this.unit.id_seccion
                        });
                        
                        secciones = _.orderBy(response.data.content.secciones, ['categoria.orden']);
                        secciones = secciones.map((seccion: any) => {
                            seccion.abreviatura = seccion.abreviatura.replace(/-/g, ' ');
                            return seccion;
                        });
                        this.sectionsList = secciones;
                    }

                    this.request.course = seccion;

                    await this.$nextTick();
                    const subject = seccion.subjects.find((subject: any) => {
                        return subject.id === this.unit.id_asignatura
                    });
                    this.request.subject = subject;

                }
                this.appLoading(false);
                    
            },
            filterPrioridades(){
                return this.roma.prioridades ? this.roma.prioridades.filter((item: any) => {
                    return item!='Priorización Roma' && item!='Con Priorización' && (
                        (this.request.schoolLevel && this.request.schoolLevel.educacion && this.request.schoolLevel.educacion.tipo == 'PARVULO' && item == 'Sin Priorización') ||
                        (this.request.schoolLevel == null || this.request.schoolLevel.educacion == null || this.request.schoolLevel.educacion.tipo != 'PARVULO')
                    );
                }): [];
            },
            filterUnidades(){
                return this.roma.unidades? this.roma.unidades.filter((unidad: any) => {
                    return (this.request.schoolLevel && this.request.schoolLevel.educacion && this.request.schoolLevel.educacion.tipo == 'PARVULO' && unidad.cod == 'UNIDAD 1') ||
                        (this.request.schoolLevel == null || this.request.schoolLevel.educacion == null || this.request.schoolLevel.educacion.tipo != 'PARVULO');
                }): [];
            }
        },
        watch: {
            async unit(newValue) {
                if (newValue) {
                    this.request.id = newValue.id;
                    this.request.name = this.roma.unidades.find((unit: any) => unit.id === newValue.id_unidad);
                    this.request.name2 = newValue.name2;
                    this.request.subject = this.roma.forPlanUnidad.find((item: any) => item.id === newValue.id_asignatura);
                    await this.$nextTick(() => {
                        if (Array.isArray(this.request.subject.niveles) && this.request.subject.niveles.length > 0) {
                            this.request.schoolLevel = this.request.subject.niveles.find((level: any) => level.id === newValue.id_nivel);
                        }
                    });

                    this.$nextTick(() => {
                        if(this.request.schoolLevel && this.request.schoolLevel.cursos){
                            if (Array.isArray(this.request.schoolLevel.cursos) && this.request.schoolLevel.cursos.length > 0) {
                                this.request.course = this.request.schoolLevel.cursos.find((course: any) => course.nombre === newValue.levelAb + ' ' + newValue.course);
                                if(this.request.course){
                                    this.request.courseName = this.request.course.nombre;
                                }
                            }
                        }
                    });

                    this.request.startDate = newValue.startDate ? newValue.startDate.substr(0, 10) : null;
                    this.request.endDate = newValue.endDate ? newValue.endDate.substr(0, 10) : null;
                    this.request.hours = newValue.hours;
                    this.request.prioridad = newValue.priority;
                    this.request.planType = newValue.planType;
                    this.request.classDays = newValue.classDays;

                    // show box if there are unitPlanOrigin_id in the unit
                    this.request.roma =  newValue.unitPlanOrigin_id ? true: false
                } else {
                    this.request = requestDefaultValues();
                    if (this.$refs.createUnitForm) this.$refs.createUnitForm.reset();

                }
            },
            modalAction: function(val){
                if(val==='Duplicate'){
                    this.request.copyFromCourse = true;
                    this.request.selectedYearToCopy = this.unit.year;
                }
            },
            'request.roma':function(val){
                if(val === true){
                    this.request.copyFromCourse = false;
                    this.request.pie = false;
                    if(this.$refs.createUnitForm){
                        this.$refs.createUnitForm.validate();
                    }                    
                }
            },
            'request.pie':function(val){
                if(val === true){
                    this.request.copyFromCourse = false;
                    this.request.roma = false;

                    this.$refs.createUnitForm.validate();
                }
            },
            'request.copyFromCourse': function(val){
                if(val === true){
                    this.request.copyOAs = true;
                    this.request.copyCoverage = true;
                    this.request.copyActivities = true;

                    this.request.roma = false;
                    this.request.pie = false;
                    this.$refs.createUnitForm.validate();
                }
            },
            'request.copyCoverage': function(val){
                if(val === true){
                    this.request.copyOAs = true;
                }
            },
            'request.copyActivities': function(val){
                if(val === true){
                    this.request.copyOAs = true;
                }
            },
            'request.schoolLevel.id'() {
                if(this.modalAction !== 'Duplicate'){
                    this.request.course = null;
                    this.request.subject = null;
                }
            },
            'request.course.idSeccion'(newValue) {
                if (newValue === this.request.selectedCourseToCopy
                    && !((this.user.roles.includes('Coordinador PIE') && !this.user.roles.includes('Profesor'))
                        || this.request.pie)) this.request.selectedCourseToCopy = null;
            },
            'request.schoolLevel'() {
                if(this.request.schoolLevel && this.request.schoolLevel.educacion && this.request.schoolLevel.educacion.tipo == 'PARVULO'){
                    if(this.modalAction == 'Add'){
                        this.request.name = this.roma.unidades.find((unidad: any) => unidad.cod == 'UNIDAD 1');
                    }
                    this.request.prioridad = 'Sin Priorización';
                }
            },
            value: function (val) {
                if (val) {
                    this.getSections();
                }
            }
        },
        directives: {
            mask
        },
        components:{
            CalendarIcon
        }
    });
